export default __webpack_public_path__ + "static/media/vi.3a2cefa9.svg";